/* BestyPop print core v2 (BP v10.20). Shared by the customizer, the staff print-file page and the Design Pass page.
   Coordinates are in inches: x = left/right from the shirt's centre line, y = down from the collar.
   Photo: {cx, cy, w, h, rot (degrees), flip}. Text: {s, f, c, cx, cy, sz, rot}. */
(function () {
  var BP = window.BPPrint = window.BPPrint || {};

  // Max front print area per size (width x height, inches) and the start below the collar. Edit here only.
  BP.SIZE_AREAS = { 'S': [11, 13], 'M': [12, 14], 'L': [13, 15], 'XL': [13, 16], '2XL': [13, 16], '3XL': [13, 16] };
  // Styles with their own areas (v10.43, owner 30 Oct 2026): 1004 Women's Crew Neck. Others use SIZE_AREAS.
  BP.STYLE_AREAS = { '1004': { 'S': [9, 12], 'M': [10, 13], 'L': [11, 14], 'XL': [11, 15], '2XL': [12, 15] },
    // Kids' crew neck (v10.45, group orders): sizes as the store lists them. PROVISIONAL until the
    // owner confirms the kids' print areas; _ref = the size the model photo stands for.
    '1007': { 'EXS-4/5YRS': [7, 8], 'EES-6/7YRS': [7.5, 9], 'ES-8/9YRS': [8, 9.5], 'S-9/10YRS': [8.5, 10], 'M-10/11YRS': [9, 10.5], 'L-11/12YRS': [9, 11], 'EL-13/14YRS': [10, 12], _ref: 'ES-8/9YRS' },
    '1010': { 'EXS-4/5YRS': [7, 8], 'EES-6/7YRS': [7.5, 9], 'ES-8/9YRS': [8, 9.5], 'S-9/10YRS': [8.5, 10], 'M-10/11YRS': [9, 10.5], 'L-11/12YRS': [9, 11], 'EL-13/14YRS': [10, 12], _ref: 'ES-8/9YRS' } };
  BP.COLLAR_GAP = 3;
  BP.DEFAULT_SIZE = 'M';

  BP.FONTS = [
    { label: 'Sassy', fam: 'Pacifico', wt: 400 },
    { label: 'Bossy', fam: 'Bebas Neue', wt: 400 },
    { label: 'Lovely', fam: 'Dancing Script', wt: 700 },
    { label: 'LIT', fam: 'Permanent Marker', wt: 400 },
    { label: 'Sci-Fi', fam: 'Orbitron', wt: 700 }
  ];
  BP.FONT_CSS = 'https://fonts.googleapis.com/css2?family=Pacifico&family=Bebas+Neue&family=Dancing+Script:wght@700&family=Permanent+Marker&family=Orbitron:wght@700&display=swap';

  BP.area = function (size, style) {   // style: a code like '1004'; default = this product page's style
    if (style === undefined) style = (BP.ENGINE_STYLES || {})[String(location.pathname).split('/').pop()];
    var t = BP.STYLE_AREAS[style] || BP.SIZE_AREAS, def = t._ref || BP.DEFAULT_SIZE;
    var key = String(size || '').toUpperCase(), a = t[key] || t[def];
    return { w: a[0], h: a[1], top: BP.COLLAR_GAP, size: t[key] ? key : def };
  };
  // The size a style's model photo stands for (the preview looks the same for every size).
  BP.refSize = function (style) { var t = BP.STYLE_AREAS[style]; return (t && t._ref) || BP.DEFAULT_SIZE; };
  BP.fontIndex = function (fam) { for (var i = 0; i < BP.FONTS.length; i++) if (BP.FONTS[i].fam === fam) return i; return 0; };
  BP.fontStr = function (t, px) { var f = BP.FONTS[BP.fontIndex(t.f)]; return f.wt + ' ' + px + 'px "' + f.fam + '", cursive'; };
  var RAD = Math.PI / 180;
  BP.norm = function (a) { a = ((Number(a) || 0) % 360 + 360) % 360; return Math.round(a * 10) / 10; };

  // Unrotated local rectangle of each layer, relative to its centre (cx, cy)
  var R = 100;
  BP.textLocal = function (ctx, t) {
    if (!t || !t.s) return null;
    ctx.save(); ctx.font = BP.fontStr(t, t.sz * R); ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    var m = ctx.measureText(t.s); ctx.restore();
    var l = m.actualBoundingBoxLeft, r = m.actualBoundingBoxRight, a = m.actualBoundingBoxAscent, d = m.actualBoundingBoxDescent;
    if (!(r > 0 || l > 0)) { l = r = m.width / 2; a = d = t.sz * R * 0.6; }
    return { x0: -l / R, y0: -a / R, x1: r / R, y1: d / R };
  };
  BP.photoLocal = function (p) { return p ? { x0: -p.w / 2, y0: -p.h / 2, x1: p.w / 2, y1: p.h / 2 } : null; };
  // Corners in inches (after rotation)
  BP.corners = function (loc, cx, cy, rot) {
    if (!loc) return null;
    var c = Math.cos((rot || 0) * RAD), s = Math.sin((rot || 0) * RAD);
    return [[loc.x0, loc.y0], [loc.x1, loc.y0], [loc.x1, loc.y1], [loc.x0, loc.y1]].map(function (p) {
      return { x: cx + p[0] * c - p[1] * s, y: cy + p[0] * s + p[1] * c };
    });
  };
  function bboxOf(pts) {
    if (!pts) return null;
    var xs = pts.map(function (p) { return p.x; }), ys = pts.map(function (p) { return p.y; });
    var x0 = Math.min.apply(null, xs), y0 = Math.min.apply(null, ys);
    return { x: x0, y: y0, w: Math.max.apply(null, xs) - x0, h: Math.max.apply(null, ys) - y0 };
  }
  BP.photoBox = function (p) { return p ? bboxOf(BP.corners(BP.photoLocal(p), p.cx, p.cy, p.rot)) : null; };
  BP.textBox = function (ctx, t) { var l = BP.textLocal(ctx, t); return l ? bboxOf(BP.corners(l, t.cx, t.cy, t.rot)) : null; };
  BP.union = function (ctx, d) {
    var boxes = [BP.photoBox(d.photo), BP.textBox(ctx, d.text)].concat((d.lines || []).map(function (t) { return BP.textBox(ctx, t); })).filter(Boolean);
    if (!boxes.length) return null;
    var x0 = Math.min.apply(null, boxes.map(function (b) { return b.x; }));
    var y0 = Math.min.apply(null, boxes.map(function (b) { return b.y; }));
    var x1 = Math.max.apply(null, boxes.map(function (b) { return b.x + b.w; }));
    var y1 = Math.max.apply(null, boxes.map(function (b) { return b.y + b.h; }));
    return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
  };
  // Is inch point inside a rotated layer?
  BP.hit = function (loc, cx, cy, rot, px, py, pad) {
    if (!loc) return false;
    var c = Math.cos(-(rot || 0) * RAD), s = Math.sin(-(rot || 0) * RAD), dx = px - cx, dy = py - cy;
    var lx = dx * c - dy * s, ly = dx * s + dy * c; pad = pad || 0;
    return lx >= loc.x0 - pad && lx <= loc.x1 + pad && ly >= loc.y0 - pad && ly <= loc.y1 + pad;
  };

  // Draw the design. inch (x, y) lands at pixel (ox + x * ppi, oy + y * ppi).
  BP.draw = function (ctx, d, photoEl, ppi, ox, oy) {
    if (d.photo && photoEl) {
      var p = d.photo;
      ctx.save();
      ctx.translate(ox + p.cx * ppi, oy + p.cy * ppi); ctx.rotate((p.rot || 0) * RAD); if (p.flip) ctx.scale(-1, 1);
      ctx.drawImage(photoEl, -p.w / 2 * ppi, -p.h / 2 * ppi, p.w * ppi, p.h * ppi);
      ctx.restore();
    }
    [d.text].concat(d.lines || []).forEach(function (t) {   // the text layer, then any extra lines (v10.47 group name)
      if (!t || !t.s) return;
      ctx.save();
      ctx.translate(ox + t.cx * ppi, oy + t.cy * ppi); ctx.rotate((t.rot || 0) * RAD);
      ctx.font = BP.fontStr(t, t.sz * ppi); ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillStyle = t.c;
      ctx.fillText(t.s, 0, 0);
      ctx.restore();
    });
  };

  BP.inch = function (n) { return (Math.round(n * 10) / 10).toFixed(1); };
  BP.deg = function (n) { var v = BP.norm(n); if (v > 180) v = Math.round((v - 360) * 10) / 10; return (v % 1 ? v.toFixed(1) : String(v)) + '°'; };
  BP.placement = function (box) {
    if (!box) return '';
    var mid = box.x + box.w / 2, side;
    if (Math.abs(mid) < 0.15) side = 'centered';
    else side = BP.inch(Math.abs(mid)) + ' in ' + (mid < 0 ? 'left' : 'right') + ' of centre (as you face the shirt)';
    return BP.inch(box.y) + ' in below collar, ' + side;
  };
  BP.sizeText = function (box) { return box ? BP.inch(box.w) + ' × ' + BP.inch(box.h) + ' in' : ''; };
  // Angles worth stating on the order (photo and text)
  BP.angleNote = function (d) {
    var parts = [];
    if (d.photo && BP.norm(d.photo.rot)) parts.push('photo ' + BP.deg(d.photo.rot));
    if (d.photo && d.photo.flip) parts.push('photo mirrored');
    if (d.text && d.text.s && BP.norm(d.text.rot)) parts.push('text ' + BP.deg(d.text.rot));
    return parts.length ? 'rotated: ' + parts.join(', ') : '';
  };

  // Compact, URL-safe data for links
  BP.encode = function (obj) {
    var b = btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
    return b.split('+').join('-').split('/').join('_').split('=').join('');
  };
  BP.decode = function (s) {
    s = String(s || '').split('-').join('+').split('_').join('/');
    while (s.length % 4) s += '=';
    return JSON.parse(decodeURIComponent(escape(atob(s))));
  };

  BP.loadImage = function (url) {
    return new Promise(function (ok, bad) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { ok(im); }; im.onerror = function () { bad(new Error('image')); };
      im.src = url && url.indexOf('//') === 0 ? location.protocol + url : url;
    });
  };
  var fontsAsked = false;
  BP.loadFonts = function () {
    if (!fontsAsked) {
      fontsAsked = true;
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = BP.FONT_CSS; document.head.appendChild(l);
    }
    if (!document.fonts) return Promise.resolve();
    return Promise.all(BP.FONTS.map(function (f) { return document.fonts.load(f.wt + ' 40px "' + f.fam + '"').catch(function () {}); }));
  };

  // Add 300 DPI (or any) metadata to a PNG blob, so print software opens it at the right inches
  var CRC = null;
  function crc32(bytes) {
    if (!CRC) { CRC = []; for (var n = 0; n < 256; n++) { var c = n; for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1; CRC.push(c >>> 0); } }
    var crc = 0xFFFFFFFF;
    for (var i = 0; i < bytes.length; i++) crc = CRC[(crc ^ bytes[i]) & 255] ^ (crc >>> 8);
    return (crc ^ 0xFFFFFFFF) >>> 0;
  }
  BP.withDpi = function (blob, dpi) {
    return blob.arrayBuffer().then(function (buf) {
      var src = new Uint8Array(buf), ppm = Math.round(dpi / 0.0254);
      var chunk = new Uint8Array(21), dv = new DataView(chunk.buffer);
      dv.setUint32(0, 9); chunk.set([112, 72, 89, 115], 4); dv.setUint32(8, ppm); dv.setUint32(12, ppm); chunk[16] = 1;
      dv.setUint32(17, crc32(chunk.subarray(4, 17)));
      var out = new Uint8Array(src.length + 21);
      out.set(src.subarray(0, 33), 0); out.set(chunk, 33); out.set(src.subarray(33), 54);
      return new Blob([out], { type: 'image/png' });
    });
  };

  // ---------- design cleaning on the BestyPop design engine (v10.37) ----------
  // The same engine as the occasion design pages: removes a plain background (screenshot box,
  // white JPG background), keeps artwork that only resembles it, trims empty edges. Busy photos
  // come back marked photo=1 and are cut out in the browser (person only) instead.
  BP.ENGINE_BASE = 'https://inventory.bestypop.in/designs';
  BP.ENGINE_URL = BP.ENGINE_BASE + '/api/custom/clean';
  // Product handle → style code, for the "Shown on" models from the Drive Models/<style> folder.
  BP.ENGINE_STYLES = { 'bestypop-men-crew-neck-customize': '1001', 'bestypop-women-customise-print': '1004', 'bestypop': '1007', 'crew': '1010' };
  // One engine reply (clean or later) → the cleaned canvas, where it sits in the upload, and how.
  function readClean(r, iw, ih) {
    var keyed = r.headers.get('X-BP-Keyed') === '1', photo = r.headers.get('X-BP-Photo') === '1';
    var method = r.headers.get('X-BP-Method') || 'rules', quality = r.headers.get('X-BP-Quality') || 'ok', later = r.headers.get('X-BP-Later') || '', kind = r.headers.get('X-BP-Kind') || 'other';
    var box = (r.headers.get('X-BP-Box') || '').split(',').map(Number), src = (r.headers.get('X-BP-Src') || '').split('x').map(Number);
    return r.blob().then(function (b) {
      return BP.loadImage(URL.createObjectURL(b)).then(function (im) {
        var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight;
        c.getContext('2d').drawImage(im, 0, 0);
        var k = src[0] ? iw / src[0] : 1;   // engine may have read a scaled copy
        var crop = box.length === 4 && box.every(isFinite) ? { x: box[0] * k, y: box[1] * k, w: box[2] * k, h: box[3] * k } : { x: 0, y: 0, w: iw, h: ih };
        return { canvas: c, crop: crop, keyed: keyed, photo: photo, method: method, quality: quality, later: later, kind: kind, blob: b };
      });
    });
  }
  BP.cleanDesign = function (file, img) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    return fetch(BP.ENGINE_URL, { method: 'POST', body: file, headers: { 'Content-Type': file.type || 'image/png' } })
      .then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.error || 'engine'); });
        return readClean(r, iw, ih);
      });
  };
  // v10.41: a better cut made in the background (the stronger model). Asks every 3 s for up to
  // 90 s; resolves to the same shape as cleanDesign, or null when there is none.
  BP.cleanLater = function (token, img) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height, tries = 0;
    return new Promise(function (ok) {
      (function ask() {
        if (++tries > 30) return ok(null);
        fetch(BP.ENGINE_BASE + '/api/custom/later/' + token).then(function (r) {
          if (r.status === 202) return setTimeout(ask, 3000);
          if (r.status !== 200) return ok(null);
          return readClean(r, iw, ih).then(ok);
        }).catch(function () { setTimeout(ask, 3000); });
      })();
    });
  };

  // What to ask ChatGPT for, by what the upload was (the engine says which; v10.41).
  BP.CLEAN_PROMPTS = {
    screenshot: 'This is a phone screenshot. Remove the background and every screen element (clock, icons, buttons, timeline, comment bar). Keep only the artwork exactly as it is, with clean sharp edges, on a transparent background. Output a high-resolution PNG at least 3000 px wide.',
    box: 'Remove the solid box behind this logo and any background. Keep only the logo and lettering exactly as they are, with crisp edges, on a transparent background. Output a high-resolution PNG at least 3000 px wide.',
    photo: 'Cut out the main subject of this photo and remove the background completely. Keep fine edges (hair, fur, thin parts) clean with no halo. Transparent background, high-resolution PNG at least 3000 px wide.',
    logo: 'Remove the background from this design. Keep every part of the artwork and lettering exactly as it is, same colours, crisp edges, on a transparent background. Output a high-resolution PNG at least 3000 px wide.'
  };
  BP.cleanPrompt = function (kind) { return BP.CLEAN_PROMPTS[kind] || BP.CLEAN_PROMPTS.logo; };

  // ---------- background removal (people), runs in the browser ----------
  var MP_V = '0.10.14', segPromise = null;
  var MP_MODEL = 'https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_multiclass_256x256/float32/latest/selfie_multiclass_256x256.tflite';
  // Load the MediaPipe module with a module script tag (keeps the asset free of import() syntax)
  function loadVision() {
    if (window.__bpVision) return Promise.resolve(window.__bpVision);
    return new Promise(function (ok, bad) {
      var done = false, t = setTimeout(function () { if (!done) bad(new Error('timeout')); }, 30000);
      window.addEventListener('bp-vision-ready', function () { done = true; clearTimeout(t); ok(window.__bpVision); }, { once: true });
      window.addEventListener('bp-vision-error', function () { done = true; clearTimeout(t); bad(new Error('load')); }, { once: true });
      var sc = document.createElement('script'); sc.type = 'module';
      sc.textContent = "imp" + "ort('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@" + MP_V + "/vision_bundle.mjs').then(function (m) { window.__bpVision = m; dispatchEvent(new Event('bp-vision-ready')); }).catch(function () { dispatchEvent(new Event('bp-vision-error')); });";
      document.head.appendChild(sc);
    });
  }
  function segmenter() {
    if (!segPromise) {
      segPromise = loadVision().then(function (mp) {
        return mp.FilesetResolver.forVisionTasks('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@' + MP_V + '/wasm').then(function (fs) {
          return mp.ImageSegmenter.createFromOptions(fs, { baseOptions: { modelAssetPath: MP_MODEL, delegate: 'CPU' }, runningMode: 'IMAGE', outputConfidenceMasks: true, outputCategoryMask: false });
        });
      });
      segPromise.catch(function () { segPromise = null; });
    }
    return segPromise;
  }
  BP.preloadCutout = function () { return segmenter().catch(function () {}); };
  // Resolves {canvas, share} with the person cut out and cropped to them, or rejects with 'noperson' / an error
  BP.removeBackground = function (img) {
    return segmenter().then(function (seg) {
      var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height, k = Math.min(1, 1024 / Math.max(iw, ih));
      var small = document.createElement('canvas'); small.width = Math.round(iw * k); small.height = Math.round(ih * k);
      small.getContext('2d').drawImage(img, 0, 0, small.width, small.height);
      var res = seg.segment(small), m = res.confidenceMasks[0], bg = m.getAsFloat32Array(), mw = m.width, mh = m.height;
      var mask = document.createElement('canvas'); mask.width = mw; mask.height = mh;
      var mg = mask.getContext('2d'), md = mg.createImageData(mw, mh), fg = 0, x0 = mw, y0 = mh, x1 = -1, y1 = -1;
      for (var i = 0; i < bg.length; i++) {
        var a = (1 - bg[i] - 0.3) / 0.4; a = a < 0 ? 0 : a > 1 ? 1 : a;
        md.data[i * 4 + 3] = Math.round(a * 255);
        if (a > 0.5) { fg++; var x = i % mw, y = (i / mw) | 0; if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
      res.close();
      var share = fg / bg.length;
      if (share < 0.02) throw new Error('noperson');
      mg.putImageData(md, 0, 0);
      // full-resolution cut-out, cropped to the person
      var sx = iw / mw, sy = ih / mh, pad = 2;
      var cx0 = Math.max(0, Math.floor((x0 - pad) * sx)), cy0 = Math.max(0, Math.floor((y0 - pad) * sy));
      var cx1 = Math.min(iw, Math.ceil((x1 + 1 + pad) * sx)), cy1 = Math.min(ih, Math.ceil((y1 + 1 + pad) * sy));
      var out = document.createElement('canvas'); out.width = cx1 - cx0; out.height = cy1 - cy0;
      var og = out.getContext('2d');
      og.drawImage(img, -cx0, -cy0, iw, ih);
      og.globalCompositeOperation = 'destination-in'; og.imageSmoothingQuality = 'high';
      og.drawImage(mask, -cx0, -cy0, iw, ih);
      og.globalCompositeOperation = 'source-over';
      return { canvas: out, share: share, crop: { x: cx0, y: cy0, w: cx1 - cx0, h: cy1 - cy0 } };
    });
  };
})();
